
import { Route } from 'vue-router';
import { Component, Vue } from 'vue-property-decorator';
import TopNavbar from '../components/navigation/TopNavbar.vue';
import GeneralMenu from '../components/navigation/GeneralMenu.vue';
import AllFiltersModal from '../components/filter/AllFiltersModal.vue';
import { Gui } from '../gui/gui';
import store from '../store/store';
@Component({
    components: {
        TopNavbar,
        GeneralMenu,
        AllFiltersModal
    }
})
export default class Root extends Vue {
    public gui: Gui = null;

    created() {
        this.gui = new Gui();
        this.$store.state.gui = this.gui;
        if (window.hasOwnProperty('doorbellOptions')) {
            (window as any).doorbellOptions.email = this.$store.state.user.user.emailAddress;
            (window as any).doorbellOptions.name = this.$store.state.user.user.fullName;
            (window as any).doorbellOptions.hideEmail = true;
        }
    }

    async mounted() {
        await this.gui.init();
        //  this.clearAllFilters();
        this.$store.state.appLoaded = true;
    }

    beforeRouteEnter(to: Route, from: Route, next: Function) {
        Root.handleIncoming(to, from, next);
    }

    beforeRouteUpdate(to: Route, from: Route, next: Function) {
        Root.handleIncoming(to, from, next);
    }

    private static handleIncoming(to: Route, from: Route, next: Function) {
        if (!to || to.name === 'root') {
            next({ name: 'overview' });
        } else {
            next();
        }
    }
}
